<template>
  <div class="history-orders-container">
    <van-nav-bar title="历史订单" left-arrow @click-left="goBack" />
    <div class="tabs-container">
      <van-tabs
        v-model="params.invoice_status"
        type="card"
        title-inactive-color="#333"
        title-active-color="#333"
        background="#fff"
      >
        <van-tab title="未开票" :name="0"></van-tab>
        <van-tab title="已开票" :name="1"></van-tab>
      </van-tabs>
    </div>
    <div class="history-orders-content">
      <van-list
        v-model="loading"
        offset="0"
        :finished="finished"
        @load="onLoadMore"
      >
        <van-cell v-for="(item, idx) in list" :key="item.id">
          <div name="title" class="order-item" @click="onItemClick(idx)">
            <div class="order-item-left">
              <van-checkbox
                icon-size="15px"
                :value="list[idx].checked"
                :disabled="!!params.invoice_status"
              />
              <div class="order-item-left-info">
                <span class="car-no">{{ item.car_no }}</span>
                <span class="order-time">{{ item.paytime }}</span>
              </div>
            </div>
            <div>
              <span v-if="item.pay_price" class="pay-price">
                {{ item.pay_price }} 元
              </span>
            </div>
          </div>
        </van-cell>
        <div name="finished" class="finished-tip">
          <span>{{ finishedText }}</span>
        </div>
      </van-list>
    </div>
    <div class="footer">
      <div class="left">
        <van-checkbox
          icon-size="17px"
          :value="allChecked"
          :disabled="!!params.invoice_status"
          @click="onAllCheckedChange"
        >
          全选
        </van-checkbox>
      </div>
      <div class="right">
        <div class="summary">
          <span class="counts">已选 {{ selectedCount }} 项</span>
          <span class="summary-amount">¥ {{ summaryAmount }}</span>
        </div>
        <van-button
          type="info"
          :disabled="!selectedCount"
          @click="onInvoiceClick"
        >
          开票
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList, invoiceVerify } from '@/api/api';
import { NavBar, List, Checkbox, Button, Cell, Tabs, Tab, Toast } from 'vant';
export default {
  name: 'HistoryOrders',
  components: {
    VanNavBar: NavBar,
    VanList: List,
    VanCheckbox: Checkbox,
    VanButton: Button,
    VanCell: Cell,
    VanTabs: Tabs,
    VanTab: Tab,
  },
  data() {
    return {
      params: {
        page: 1,
        pagesize: 10,
        invoice_status: 0,
      },
      list: [],
      total: 0,
      loading: false,
      finished: false,
      summaryAmount: '0.00',
    };
  },
  computed: {
    allChecked() {
      return this.list.every(item => item.checked);
    },
    selectedItems() {
      return this.list.filter(item => item.checked);
    },
    selectedCount() {
      return this.selectedItems.length;
    },
    finishedText() {
      return this.total === this.list.length ? '没有更多了' : '加载中...';
    },
  },
  watch: {
    selectedItems(v) {
      if (v.length) {
        this.getSummaryAmount();
      } else {
        this.summaryAmount = '0.00';
      }
    },
    'params.invoice_status': {
      handler() {
        this.params.page = 1;
        this.$nextTick(() => {
          this.onLoadMore();
        });
      },
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async onLoadMore() {
      this.loading = true;
      this.finished = true;
      const loading = Toast.loading({
        duration: 0,
      });
      const {
        data: { total, data },
      } = await getOrderList(this.params).finally(() => {
        loading.clear();
        this.loading = false;
      });
      this.total = total;
      const { page } = this.params;
      if (page === 1) {
        this.list = data;
      } else {
        this.list = []
          .concat(this.list, data)
          .map(_ => ({ ..._, checked: _.checked || false }));
      }
      if (this.list.length >= total) {
        this.finished = true;
      } else {
        this.params.page++;
        this.finished = false;
      }
    },
    onItemClick(idx) {
      this.$set(this.list[idx], 'checked', !this.list[idx].checked);
    },
    onAllCheckedChange(e) {
      if (!this.allChecked) {
        this.list = this.list.map(item => ({
          ...item,
          checked: true,
        }));
      } else {
        this.list = this.list.map(item => ({ ...item, checked: false }));
      }
    },
    async getSummaryAmount() {
      const {
        data: { total_pay_fee },
      } = await invoiceVerify({
        ids: this.selectedItems.map(item => item.id),
      });
      if (typeof total_pay_fee === 'number') {
        this.summaryAmount = total_pay_fee.toFixed(2);
      } else {
        this.summaryAmount = total_pay_fee;
      }
    },
    onInvoiceClick() {
      this.$router.push({
        name: 'Invoice',
        query: {
          ids: this.selectedItems.map(item => item.id),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.history-orders-container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;

  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-bottom: 1px solid #f0f0f0;

    .icon {
      padding: 8px;
      position: absolute;
      left: 0;
      font-size: 18px;

      &:active {
        opacity: 0.5;
      }
    }
  }

  .tabs-container {
    background-color: #fff;
    padding: 10px 0;

    ::v-deep.van-tabs__nav--card {
      border-color: #1989fa;
      border-radius: 5px;
      overflow: hidden;
    }

    ::v-deep.van-tab {
      background-color: #fff;
      color: #1989fa !important;

      &--active {
        background-color: #1989fa;
        color: #fff !important;
      }

      &:not(:last-child) {
        border-right-color: #1989fa;
      }
    }
  }

  .history-orders-content {
    flex: 1;
    overflow-x: hidden;
    overflow-y: scroll;

    .order-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-left {
        display: flex;
        align-items: center;
        gap: 10px;

        &-info {
          display: flex;
          flex-direction: column;
          gap: 5px;

          .car-no {
            font-size: 14px;
            line-height: 16px;
            color: #333;
          }

          .order-time {
            font-size: 12px;
            line-height: 14px;
            color: #999;
          }
        }
      }

      .pay-price {
        color: red;
        font-weight: bold;
      }
    }

    .finished-tip {
      padding: 10px 15px;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }

  .footer {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;

    .right {
      display: flex;
      align-items: center;
      gap: 10px;

      .summary {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .counts {
          font-size: 12px;
          line-height: 14px;
          color: #999;
        }

        .summary-amount {
          color: red;
          font-weight: bold;
        }
      }
      .van-button {
        height: fit-content;
        padding: 8px 20px;
        line-height: 16px;
        border-radius: 5px;
      }
    }
  }
}
</style>
